import { getGroupTitle, getTaskTitle } from '@/Client/Lib/scopeNavigatorPartPresentersLib';
import type { ProgressUpdateTarget } from './progressUpdateModalTypes';

export const getProgressUpdateModalTitle = (target: ProgressUpdateTarget): string => getTaskTitle(target.task, 'Untitled task');

export const getProgressUpdateModalSubtitle = (target: ProgressUpdateTarget): string => {
  const parts = [
    target.group ? getGroupTitle(target.group) : undefined,
    target.task.template?.category,
  ].filter(Boolean);
  return parts.join(' · ');
};
